import React, { useMemo, useState, useEffect } from "react";

//Import Image
import lightLogo from "../../assets/images/light-logo.png";
import darkLogo from "../../assets/images/dark-logo.png";

import resetPasswordImage from "../../assets/images/auth/reset-password.png";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { resetPassword, validateResetToken } from "../../services/authService";

const passwordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

const ResetPassword = () => {
  document.title = "Redefinir Password | Recruitment";

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCheckingToken, setIsCheckingToken] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setIsTokenValid(false);
        setIsCheckingToken(false);
        return;
      }

      try {
        await validateResetToken(token);
        setIsTokenValid(true);
      } catch (error) {
        console.error("[auth] Token de reset invalido", error);
        setIsTokenValid(false);
      } finally {
        setIsCheckingToken(false);
      }
    };

    checkToken();
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!token || !isTokenValid) {
      toast.error("Token invalido ou expirado.");
      return;
    }

    if (!passwordPolicy.test(password)) {
      toast.error(
        "A password deve ter 8+ caracteres com maiuscula, minuscula, numero e simbolo.",
      );
      return;
    }

    if (password !== confirmPassword) {
      toast.error("A confirmacao de password nao corresponde.");
      return;
    }

    setIsSubmitting(true);

    try {
      await resetPassword({ token, password, confirmPassword });
      toast.success("Password redefinida com sucesso.");
      navigate("/signin");
    } catch (error) {
      console.error("[auth] Erro ao redefinir password", error);
      toast.error(error.message || "Erro ao redefinir password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="main-content">
        <div className="page-content">
          <section className="bg-auth">
            <Container>
              <Row className="justify-content-center">
                <Col xl={10} lg={12}>
                  <Card className="auth-box">
                    <Row className="g-0">
                      <Col lg={6} className="text-center">
                        <CardBody className="p-4">
                          <Link
                            className="text-dark fw-bold fs-3 mx-auto d-flex align-items-center justify-content-center gap-2"
                            to="/"
                          >
                            <img
                              src={lightLogo}
                              alt=""
                              height="30"
                              className="logo-dark"
                            />
                            <img
                              src={darkLogo}
                              alt=""
                              height="30"
                              className="logo-light"
                            />
                            <span>Recruitment</span>
                          </Link>
                          <div className="mt-5">
                            <img
                              src={resetPasswordImage}
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                        </CardBody>
                      </Col>
                      <Col lg={6}>
                        <CardBody className="auth-content p-5 h-100 text-white">
                          <div className="text-center mb-4">
                            <h5>Redefinir Senha</h5>
                            <p className="text-white-50">
                              Defina uma nova senha para sua conta.
                            </p>
                          </div>

                          {isCheckingToken ? (
                            <div
                              className="alert alert-info text-center"
                              role="alert"
                            >
                              Validando token...
                            </div>
                          ) : null}

                          {!isCheckingToken && !isTokenValid ? (
                            <div className="alert alert-danger" role="alert">
                              O link de recuperacao e invalido ou expirou.
                              Solicite um novo link.
                            </div>
                          ) : null}

                          <Form
                            className="auth-form text-white"
                            onSubmit={handleSubmit}
                          >
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="newPassword"
                              >
                                Nova Password
                              </label>
                              <Input
                                type="password"
                                className="form-control"
                                id="newPassword"
                                placeholder="Digite a nova password"
                                value={password}
                                onChange={(event) =>
                                  setPassword(event.target.value)
                                }
                                required
                                disabled={
                                  !isTokenValid ||
                                  isSubmitting ||
                                  isCheckingToken
                                }
                              />
                            </div>

                            <div className="mb-4">
                              <label
                                className="form-label"
                                htmlFor="confirmPassword"
                              >
                                Confirmar Password
                              </label>
                              <Input
                                type="password"
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Confirme a nova password"
                                value={confirmPassword}
                                onChange={(event) =>
                                  setConfirmPassword(event.target.value)
                                }
                                required
                                disabled={
                                  !isTokenValid ||
                                  isSubmitting ||
                                  isCheckingToken
                                }
                              />
                            </div>

                            <div
                              className="alert alert-warning text-center small"
                              role="alert"
                            >
                              A password deve ter 8+ caracteres, com letra
                              maiuscula, minuscula, numero e simbolo.
                            </div>

                            <div className="mt-3">
                              <button
                                type="submit"
                                className="btn btn-white w-100"
                                disabled={
                                  !isTokenValid ||
                                  isSubmitting ||
                                  isCheckingToken
                                }
                              >
                                {isSubmitting
                                  ? "A redefinir..."
                                  : "Redefinir Password"}
                              </button>
                            </div>
                          </Form>
                          <div className="mt-5 text-center text-white-50">
                            <p>
                              Precisa de um novo link?{" "}
                              <Link
                                to="/forgot-password"
                                className="fw-medium text-white text-decoration-underline"
                              >
                                Solicitar novamente
                              </Link>
                            </p>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
